import { Caption1, Caption2, Flex, H3, H5, H6 } from '@components/atoms'
import { auth_artist_img, upload_photo_img } from '@images/'
import {
  comments_fill_24,
  notice_img,
  sns_instagram,
  sns_twitter,
  sns_youtube,
  thumbup_fill_24_off,
  thumbup_fill_24_on,
  view_fill_24px,
} from '@images/index'
import {
  converseCommentUnitEng,
  convertToPricingComma,
  dateFromString,
  dateTodayYMDMM,
} from '@utils/format'

import React from 'react'
import { STORAGE_URL } from '@consts'
import { colors } from '@colors/'
import qs from 'qs'
import styled from 'styled-components'
import { tiktokTrackEvent } from '@utils/tiktok'
import Image from './Image'

const HomeInPlamListItem = ({ item, onClick, index }) => {
  if (item) {
    return (
      <ItemBox
        onClick={() => {
          tiktokTrackEvent('ViewContent', {
            content_id: item._id,
          })
          onClick(item)
        }}
      >
        <Flex style={{ gap: '16px' }}>
          <Flex>
            <RankText>{index + 1}</RankText>
          </Flex>
          <Flex
            type="column"
            style={{
              flex: 1,
            }}
          >
            <Flex justify={'space-between'}>
              <Flex type={'column'}>
                <Flex type={'column'}>
                  <Flex align="center">
                    <TitleText>{item.title}</TitleText>
                  </Flex>
                  {/* <BodyText type={'Regular'}>{item?.text}</BodyText> */}
                </Flex>
                <Flex style={{ gap: '12px', marginTop: '8px' }}>
                  <Flex align={'center'}>
                    <Image
                      src={
                        item?.isLike ? thumbup_fill_24_on : thumbup_fill_24_off
                      }
                      size={['20px', '20px']}
                      style={{
                        marginRight: '4px',
                      }}
                    />
                    <Caption1 color={'#646464'}>
                      {item?.likeCount > 100000
                        ? '10만+'
                        : convertToPricingComma(item?.likeCount)}
                    </Caption1>
                  </Flex>
                  <Flex align={'center'}>
                    <Image
                      src={comments_fill_24}
                      size={['20px', '20px']}
                      style={{
                        marginRight: '4px',
                      }}
                    />
                    <Caption1 color={'#646464'}>
                      {item?.likeCount > 100000
                        ? '10만+'
                        : convertToPricingComma(item?.commentCount)}
                    </Caption1>
                  </Flex>
                  <Flex align={'center'}>
                    <Image
                      src={view_fill_24px}
                      size={['20px', '20px']}
                      style={{
                        marginRight: '4px',
                      }}
                    />
                    <Caption1 color={'#646464'}>
                      {item?.likeCount > 100000
                        ? '10만+'
                        : convertToPricingComma(item?.viewCount)}
                    </Caption1>
                  </Flex>
                </Flex>
              </Flex>
              {item.imageOriginalPathList &&
                item.imageOriginalPathList.length > 0 && (
                  <ThumbnailBox>
                    <img
                      src={
                        STORAGE_URL +
                        (item.image480PathList && item.image480PathList[0])
                      }
                      onError={e => {
                        e.target.src = upload_photo_img
                      }}
                      alt="exist_img"
                      style={{
                        width: '60px',
                        height: '60px',
                        objectFit: 'cover',
                      }}
                    />
                  </ThumbnailBox>
                )}
            </Flex>
          </Flex>
        </Flex>
      </ItemBox>
    )
  }

  return <></>
}

export default HomeInPlamListItem

const ItemBox = styled(Flex)`
  /* margin-left: 0px; */
  width: calc(100%);
  /* border-bottom: solid 1px ${colors.whitef4}; */
  box-sizing: border-box;
  /* height: 106px; */
  cursor: pointer;
  flex-direction: column;
`

const TitleText = styled(H5)`
  width: fit-content;
  max-width: 100%;
  line-height: 24px;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  word-wrap: break-word;
  word-break: break-all;
  font-weight: 500;
`
const BodyText = styled(H6)`
  /* width: fit-content; */
  /* max-width: 100%; */
  line-height: 24px;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  word-wrap: break-word;
  word-break: break-all;
`

const CommentCountBox = styled(Flex)`
  flex-direction: column;
  max-width: 48px;
  min-width: 48px;
  height: 48px;
  padding: 6px 9px;
  background-color: ${colors.whitef4};
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
`

const ThumbnailBox = styled(Flex)`
  flex-direction: column;
  max-width: 60px;
  min-width: 60px;
  height: 60px;
  margin-left: 8px;
  border-radius: 8px;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  overflow: hidden;
`

const FromArtistImg = styled.img`
  width: 12px;
  height: 12px;
  margin-left: 4px;
`

const SnsImg = styled.img`
  width: 16px;
  height: 16px;
  box-sizing: border-box;
  object-fit: cover;
  margin-left: 8px;
`
const Br = styled(Flex)`
  margin-left: 0px;
  width: calc(100% + 0px);
  border-bottom: solid 1px ${colors.whitef4};
  margin-top: 24px;
`
const RankText = styled(H3)`
  color: var(--grey-grey_80, #242424);
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
`
